import { render, staticRenderFns } from "./LoaderWrapper.vue?vue&type=template&id=3bf7f464&scoped=true&"
import script from "./LoaderWrapper.vue?vue&type=script&lang=ts&"
export * from "./LoaderWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./LoaderWrapper.vue?vue&type=style&index=0&id=3bf7f464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf7f464",
  null
  
)

export default component.exports